import React, { useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Checkbox, Col, Form, Input, InputNumber, Row, Select, Spin } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { checkInQuarterQuantitative, getKrQuantiCheckInQuarter, reset } from 'app/entities/checkIn/checkIn.reducer';
import { getBoxWorkStatus } from 'app/entities/common/common.reducer';
import ObjectiveUpdate from 'app/entities/objective/form/objective-update';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import { QuantitativeEvaluationType } from 'app/shared/model/enum/quantitativeEvaluation.enum';
import { StatusType } from 'app/shared/model/enum/status.enum';
import { TrendingTypes } from 'app/shared/model/enum/trending.enum';
import { formatNumber, parseNumber } from 'app/shared/util/help';
import { displayPercent, percent } from 'app/shared/util/percent';
import { filterOption } from 'app/shared/util/select-filter';
import * as _ from 'lodash';
import KRUpdate from '../../kr-update';

type IReportQualitativeResult = {
  handleClose: () => void;
  krCheckIn?: any;
  handleNextData: () => void;
  hideNextKr: boolean;
};

export const ReportQuantitativeResult = ({ handleClose, krCheckIn, handleNextData, hideNextKr }: IReportQualitativeResult) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const filters = useAppSelector(state => state.filters.orgCheckIn);
  const workStatusList = useAppSelector(state => state.common.workStatus);
  const entity = useAppSelector(state => state.checkIn.entity);

  const [isOpenModalFormKr, setIsOpenModalFormKr] = useState(false);
  const [isOpenModalFormObjective, setIsOpenModalFormObjective] = useState(false);
  const [isUpdating, setUpdating] = useState(false);
  const modalContentRef = useRef(null);

  // watch values form
  const workStatusMonthValues = Form.useWatch('workStatusMonth', form);
  const metricValuePrevMonthValues = Form.useWatch('actualResultMonth', form);
  const metricValueMonthValues = Form.useWatch('metricValueMonth', form);
  const metricValueQuarterValues = Form.useWatch('metricValueQuarter', form);
  const accumulatedResultValues = Form.useWatch('accumulatedResult', form);
  const workStatusQuarterValues = Form.useWatch('workStatusQuarter', form);
  const metricValueFirst = Form.useWatch('metricValue-0', form);
  const metricValueSecond = Form.useWatch('metricValue-1', form);
  const metricValueThird = Form.useWatch('metricValue-2', form);
  // define data collapse

  useEffect(() => {
    if (krCheckIn && filters) {
      innitData();
    }
  }, [krCheckIn, filters]);

  useEffect(() => {
    if (entity) {
      form.setFieldValue('planPeriodName', entity?.planPeriodName)
      form.setFieldValue('reportScheduleName', entity?.reportScheduleName)
      if (entity?.keyResultPrevMonth) {
        form.setFieldValue('actualResultMonth', entity?.keyResultPrevMonth?.actualResult)
      }
      if (entity?.keyResultMonth) {
        form.setFieldValue('metricValueMonth', entity?.keyResultMonth?.result);
        form.setFieldValue('workStatusMonth', entity?.keyResultMonth?.workStatus);
        form.setFieldValue('estimatePointMonth', displayPercent(entity?.keyResultMonth?.estimatePoint));
        form.setFieldValue('unFinishNoteMonth', entity?.keyResultMonth?.unFinishNote);
      }
      if (entity?.keyResultQuarter) {
        form.setFieldValue('workStatusQuarter', entity?.keyResultQuarter?.workStatus);
        form.setFieldValue('unFinishNoteQuarter', entity?.keyResultQuarter?.unFinishNote);
        form.setFieldValue('metricValueQuarter', entity?.keyResultQuarter?.result);
        form.setFieldValue('estimatePointQuarter', parseFloat(displayPercent(entity?.keyResultQuarter?.estimatePoint).toFixed(2)));
        form.setFieldValue('accumulatePoint', parseFloat(displayPercent(entity?.keyResultQuarter?.accumulatePoint).toFixed(2)));
      }
      if (entity?.adjustment) {
        form.setFieldValue('reason', entity?.adjustment?.adjustmentReason)
        form.setFieldValue('issue', entity?.adjustment?.adjustmentIssue)
        form.setFieldValue('krAdjustmentNote', entity?.adjustment?.adjustmentNote)
        form.setFieldValue('solution', entity?.adjustment?.adjustmentSolution)
        form.setFieldValue('adjustmentPredictNote', entity?.adjustment?.adjustmentPredictNote)
      }
    }
  }, [entity]);

  useEffect(() => {
    if (entity?.krMetaData?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point) {
      if (entity?.keyResultMonth?.metricValue !== 0) {
        const result = displayPercent(
          calculatorPercentByTrending(entity?.krMetaData?.metricType, metricValueMonthValues, entity?.keyResultMonth?.metricValue),
        );
        if (_.isInteger(result)) form.setFieldValue('estimatePointMonth', result);
        else form.setFieldValue('estimatePointMonth', parseFloat(result.toFixed(2)));
      }
    }
  }, [metricValueMonthValues]);

  useEffect(() => {
    form.validateFields(['metricValue-0', 'metricValue-1', 'metricValue-2']).catch(err => {
      return;
    }).then(() => {
      if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
        const value: any = entity?.adjustment?.krNextQuarter?.metricValue - ((metricValueFirst ?? 0) + (metricValueSecond ?? 0));
        form.setFieldsValue({ 'metricValue-2': _.round(value, 10) })
      }
    });
  }, [metricValueFirst, metricValueSecond, metricValueThird]);

  useEffect(() => {
    if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
      const valueConfirmPreMonth = metricValuePrevMonthValues !== 0 ? ((metricValuePrevMonthValues ?? 0) - (entity?.keyResultPrevMonth?.result ?? 0)) : 0
      const value =
        (entity?.keyResultQuarter?.result ?? 0) + (metricValueMonthValues ?? 0) -
        (entity?.keyResultMidMonth?.result ?? 0) +
        valueConfirmPreMonth;
      if (_.isInteger(value)) form.setFieldValue('metricValueQuarter', value);
      else form.setFieldValue('metricValueQuarter', parseFloat(value.toFixed(2)));
    }
    // if (entity?.krMetaData?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point) {
    // }
  }, [metricValueMonthValues, metricValuePrevMonthValues]);

  useEffect(() => {
    if (entity?.krMetaData?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point) {
      if (entity?.keyResultQuarter?.metricValue !== 0) {
        const result = displayPercent(
          calculatorPercentByTrending(
            entity?.krMetaData?.metricType,
            metricValueQuarterValues,
            entity?.keyResultQuarter?.metricValue,
          ),
        );
        if (_.isInteger(result)) form.setFieldValue('estimatePointQuarter', result);
        else form.setFieldValue('estimatePointQuarter', parseFloat(result.toFixed(2)));
      }
    }
    if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
      const value =
        (entity?.keyResultQuarter?.accumulateResult ?? 0) + parseFloat((metricValueQuarterValues ?? 0)) - (entity?.keyResultQuarter?.result ?? 0);
      if (_.isInteger(value)) form.setFieldValue('accumulatedResult', value);
      else form.setFieldValue('accumulatedResult', parseFloat(value.toFixed(2)));
    }
  }, [metricValueQuarterValues]);

  useEffect(() => {
    if (entity?.krMetaData?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point) {
      if (entity?.keyResultYear?.metricValue !== 0) {
        const result = displayPercent(
          calculatorPercentByTrending(entity?.krMetaData?.metricType, accumulatedResultValues, entity?.keyResultYear?.metricValue),
        );
        if (_.isInteger(result)) form.setFieldValue('accumulatePoint', result);
        else form.setFieldValue('accumulatePoint', parseFloat(result.toFixed(2)));
      }
    }
  }, [accumulatedResultValues]);

  const innitData = () => {
    dispatch(getBoxWorkStatus({ statusType: 1 }));
    dispatch(getKrQuantiCheckInQuarter(krCheckIn?.id));
  };

  const MapperPayload = (values: any) => {
    const {
      workStatusMonth,
      metricValueMonth,
      unFinishNoteMonth,
      workStatusQuarter,
      metricValueQuarter,
      unFinishNoteQuarter,
      accumulatedResult,
      solution,
      reason,
      issue,
      krAdjustmentNote,
      sendingNotification,
      reportSchedularId,
      estimatePointMonth,
      estimatePointQuarter,
      reportScheduleName,
      accumulatePoint,
      planPeriodName,
      adjustmentPredictNote,
      actualResultMonth,
      ...remainingValues
    } = values;
    // Khởi tạo mảng khóa
    const keys = Object.keys(remainingValues);

    // Chia mảng thành các nhóm nhỏ, mỗi nhóm có 3 phần tử
    const groupedKeys = _.chunk(keys, 1);
    const subs = _.map(groupedKeys, group => {
      const mapper = _.map(group, key => {
        return remainingValues[key];
      });
      return _.zipObject(['metricValue'], mapper);
    });
    const combinedSubs = subs.map((item, index) => {
      if (item.metricValue !== null && item.metricValue !== undefined) {
        return {
          ...item,
          planPeriodId: entity?.adjustment?.krApproved[index].planPeriodId,
        };
      }
    });

    const valuePreMonth = {
      actualResult: metricValuePrevMonthValues,
    };

    const valueMonth = {
      // reportSchedularId,
      // reportObjectId: krCheckIn?.id,
      // planPeriodId: entity?.keyResultMonth?.planPeriodId,
      workStatus: workStatusMonth,
      result: metricValueMonth,
      unFinishNote: unFinishNoteMonth,
      estimatePoint: percent(estimatePointMonth),
    };
    const valueQuarter = {
      // reportSchedularId,
      // reportObjectId: krCheckIn?.id,
      // planPeriodId: entity?.keyResultQuarter?.planPeriodId,
      workStatus: workStatusQuarter,
      result: metricValueQuarter,
      unFinishNote: unFinishNoteQuarter,
      accumulatedResult,
      accumulatePoint,
      estimatePoint: percent(estimatePointQuarter),
    };
    const valueAdjustment = {
      adjustmentSolution: solution,
      adjustmentPredictNote,
      adjustmentIssue: issue,
      adjustmentNote: krAdjustmentNote,
      sendingNotification,
      krApproved: _.filter(combinedSubs, (o) => { return o !== null && o !== undefined }),
    };
    return { valueQuarter, valueMonth, valuePreMonth, valueAdjustment };
  };

  const handleSubmit = values => {
    const { valueQuarter, valueMonth, valuePreMonth, valueAdjustment } = MapperPayload(values);
    const payload = {
      krId: krCheckIn?.id,
      keyResultPrevMonth: valuePreMonth,
      keyResultMonth: valueMonth,
      keyResultQuarter: valueQuarter,
      adjustment: valueAdjustment
    }
    setUpdating(true);
    dispatch(checkInQuarterQuantitative(payload))
      .then(response => {
        const isFailed = _.some(response, (o: any) => {
          return !o;
        });
        if (isFailed) return;
        handleClose();
      })
      .catch(err => {
        return err;
      })
      .finally(() => {
        setUpdating(false);
      });
  };

  const handleNextKr = () => {
    form
      .validateFields()
      .then(values => {
        const { valueQuarter, valueMonth, valuePreMonth, valueAdjustment } = MapperPayload(values);
        const payload = {
          krId: krCheckIn?.id,
          ...valuePreMonth,
          ...valueMonth,
          ...valueQuarter,
          ...valueAdjustment
        }
        setUpdating(true);

        dispatch(checkInQuarterQuantitative(payload))
          .then(response => {
            const isFailed = _.some(response, (o: any) => {
              return !o.payload;
            });
            if (isFailed) return;
            form.resetFields();
            dispatch(reset());
            form.scrollToField('reportScheduleName');
            handleNextData();
          })
          .catch(err => {
            return err;
          })
          .finally(() => {
            setUpdating(false);
          });
      })
      .catch(() => {
        return;
      });
  };

  const handleEditKr = () => {
    setIsOpenModalFormKr(true);
  };

  const handleCloseModelKr = () => {
    setIsOpenModalFormKr(false);
  };

  const handleEditObjective = () => {
    setIsOpenModalFormObjective(true);
  };

  const handleCloseModelObjective = () => {
    setIsOpenModalFormObjective(false);
  };

  const calculatorPercentByTrending = (calculation, numerator, denominator): number => {
    if (calculation === TrendingTypes.Above) {
      if (denominator > 0) return (numerator ?? 0) / denominator;
      return 0;
    } else {
      if (numerator > 0) return denominator / numerator;
      return 0;
    }
  };

  return (
    <Spin spinning={isUpdating} delay={500}>
      <Form ref={modalContentRef} size="large" form={form} className="fw-bold" onFinish={handleSubmit} layout="vertical">
        <Title className="fw-bold" level={2}>
          {`Báo cáo thực hiện KR ${filters?.accountableName ? filters.accountableName : ''}`}
          {/* {`Báo cáo thực hiện KR quý 1`} */}
        </Title>
        <Row>
          <Col md={5}>
            <Form.Item label="Kỳ kế hoạch" name={'planPeriodName'}>
              {/* <Input className="w-100" disabled value={filtersObjective?.planPeriodName} size="large" /> */}
              <Input className="w-100" disabled size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Kỳ báo cáo" name={'reportScheduleName'}>
              <Input className="w-100" readOnly size="large" />
            </Form.Item>
          </Col>
          {/* <Col md={1} />
          <Col>
            <div className="mt-4">
              <span className="cursor-pointer text-primary" onClick={() => handleEditKr()}>
                {`Xem chi tiết KR >`}
              </span>
              <br />
              <span className="cursor-pointer text-primary" onClick={() => handleEditObjective()}>
                {`Xem chi tiết mục tiêu >`}
              </span>
            </div>
          </Col> */}
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label={`Mục tiêu - ${entity?.objective?.code}`}>
              <TextArea rows={1} className="w-100" disabled value={entity?.objective?.purpose} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Lĩnh vực">
              <Input className="w-100" disabled value={entity?.objective?.fieldName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Dự án">
              <Input className="w-100" disabled value={entity?.objective?.projectName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label="Mảng công việc">
              <Input className="w-100" disabled value={entity?.objective?.workTypeName} size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Form.Item label="Mã">
              <Input className="w-100" disabled value={entity?.keyResultYear?.code} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={8}>
            <Form.Item label="Tên chỉ tiêu">
              <Input className="w-100" disabled value={entity?.keyResultYear?.metricName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Đơn vị tính">
              <Input className="w-100" disabled value={entity?.keyResultYear?.metricUnit} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Chỉ tiêu năm">
              <InputNumber
                className="w-100"
                formatter={formatNumber}
                parser={parseNumber}
                disabled
                value={_.isInteger(entity?.keyResultYear?.metricValue) ? entity?.keyResultYear?.metricValue : entity?.keyResultYear?.metricValue?.toFixed(2)}
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="fw-bold h3" md={24}>
            Chốt kết quả thực hiện {entity?.keyResultPrevMonth?.name}
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Form.Item label={`Chỉ tiêu ${entity?.keyResultPrevMonth?.name}`}>
              <InputNumber
                className="w-100"
                formatter={formatNumber}
                parser={parseNumber}
                disabled
                value={_.isInteger(entity?.keyResultPrevMonth?.metricValue) ? entity?.keyResultPrevMonth?.metricValue : entity?.keyResultPrevMonth?.metricValue?.toFixed(2)}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label={`Ước thực hiện ${entity?.keyResultPrevMonth?.name}`}>
              <InputNumber
                className="w-100"
                formatter={formatNumber}
                parser={parseNumber}
                disabled
                value={_.isInteger(entity?.keyResultPrevMonth?.result) ? entity?.keyResultPrevMonth?.result : entity?.keyResultPrevMonth?.result?.toFixed(2)}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label={`Chốt thực hiện ${entity?.keyResultPrevMonth?.name}`} name={'actualResultMonth'} rules={[{ required: true, message: 'Vui lòng nhập' }]}>
              <InputNumber step={0.01} precision={2} formatter={formatNumber} parser={parseNumber} className="w-100" size="large" />
            </Form.Item>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="fw-bold h3" md={24}>
            Thực hiện {entity?.keyResultQuarter?.name}
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Form.Item label={`Chỉ tiêu ${entity?.keyResultQuarter?.name}`}>
              <InputNumber
                className="w-100"
                formatter={formatNumber}
                parser={parseNumber}
                disabled
                value={_.isInteger(entity?.keyResultQuarter?.metricValue) ? entity?.keyResultQuarter?.metricValue : entity?.keyResultQuarter?.metricValue?.toFixed(2)}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item
              label={`Chỉ tiêu ${entity?.keyResultMonth?.name}`}
            >
              <InputNumber
                formatter={formatNumber}
                parser={parseNumber}
                className="w-100"
                disabled
                value={_.isInteger(entity?.keyResultMonth?.metricValue) ? entity?.keyResultMonth?.metricValue : entity?.keyResultMonth?.metricValue?.toFixed(2)}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item
              label={`Thực hiện ${entity?.keyResultMonth?.name}`}
              rules={[{ required: entity?.keyResultMonth?.metricValue !== 0 ? true : false, message: `Hãy nhập thực hiện ${entity?.keyResultMonth?.name}` }]}
              name={'metricValueMonth'}
            >
              <InputNumber step={0.01} precision={2} formatter={formatNumber} parser={parseNumber} className="w-100" size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item
              label={`Thực hiện ${entity?.keyResultQuarter?.name}`}
              name={'metricValueQuarter'}
              rules={[{ required: krCheckIn?.krType !== KrTypes.AccumulateQuantitative ? true : false, message: `Hãy nhập thực hiện ${entity?.keyResultQuarter?.name}` }]}
            >
              <InputNumber step={0.01} precision={2} disabled={krCheckIn?.krType === KrTypes.AccumulateQuantitative} formatter={formatNumber} parser={parseNumber} className="w-100" size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            {krCheckIn?.krType === KrTypes.AccumulateQuantitative && (
              <Form.Item label="Thực hiện lũy kế từ đầu năm" name={'accumulatedResult'}>
                <InputNumber
                  disabled={krCheckIn?.krType === KrTypes.AccumulateQuantitative}
                  formatter={formatNumber}
                  parser={parseNumber}
                  className="w-100"
                  size="large"
                />
              </Form.Item>
            )}
          </Col>
        </Row>
        <Row>
          <Col md={9}>
            <Form.Item label="Tỷ lệ hoàn thành (%)">
              <TextArea
                rows={1}
                disabled
                className="w-100"
                value={entity?.krMetaData?.evaluationMethodQuantitativeNote}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label={`KR ${entity?.keyResultMonth?.name}`} name={'estimatePointMonth'}>
              <InputNumber
                disabled={entity?.krMetaData?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point}
                formatter={formatNumber}
                parser={parseNumber}
                className="w-100"
                size="large"
                addonAfter="%"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item rules={[{
              required: entity?.krMetaData?.evaluationMethodQuantitative === QuantitativeEvaluationType.SelfDefinition,
              message: 'Vui lòng nhập giá trị'
            }]} label={`KR ${entity?.keyResultQuarter?.name}`} name={'estimatePointQuarter'}>
              <InputNumber
                disabled={entity?.krMetaData?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point}
                formatter={formatNumber}
                parser={parseNumber}
                className="w-100"
                size="large"
                addonAfter="%"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            {krCheckIn?.krType === KrTypes.AccumulateQuantitative && (
              <Form.Item label="Lũy kế so với KR năm" name={'accumulatePoint'}>
                <InputNumber
                  disabled={entity?.krMetaData?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point}
                  formatter={formatNumber}
                  parser={parseNumber}
                  className="w-100"
                  size="large"
                  addonAfter="%"
                />
              </Form.Item>
            )}
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item
              label={`Tình trạng KR ${entity?.keyResultMonth?.name}`}
              rules={[{ required: entity?.keyResultMonth?.metricValue !== 0 ? true : false, message: `Hãy chọn tình trạng kr ${entity?.keyResultMonth?.name}` }]}
              name="workStatusMonth"
            >
              <Select
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={workStatusList}
                placeholder="Chọn tình trạng"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item
              label={`Tình trạng KR ${entity?.keyResultQuarter?.name}`}
              rules={[{ required: entity?.keyResultQuarter?.metricValue !== 0 ? true : false, message: `Hãy chọn tình trạng kr ${entity?.keyResultQuarter?.name}` }]}
              name="workStatusQuarter"
            >
              <Select
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={workStatusList}
                placeholder="Chọn tình trạng"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            {(workStatusMonthValues === StatusType.Postponed ||
              workStatusMonthValues === StatusType.Cancel ||
              workStatusMonthValues === StatusType.NotCompleted) &&
              entity?.keyResultMonth?.metricValue !== 0 && (
                <Form.Item
                  label="Lý do (Không hoàn thành/Tạm dừng/Hủy)"
                  rules={[
                    {
                      required:
                        workStatusMonthValues === StatusType.Postponed ||
                        workStatusMonthValues === StatusType.Cancel ||
                        workStatusMonthValues === StatusType.NotCompleted,
                      message: `Hãy nhập lý do`,
                    },
                  ]}
                  name={'unFinishNoteMonth'}
                >
                  <TextArea rows={6} placeholder="Nhập nhập lý do" size="large" />
                </Form.Item>
              )}
          </Col>
          <Col md={1} />
          <Col md={12}>
            {(workStatusQuarterValues === StatusType.Postponed ||
              workStatusQuarterValues === StatusType.Cancel ||
              workStatusQuarterValues === StatusType.NotCompleted) &&
              entity?.keyResultQuarter?.metricValue !== 0 && (
                <Form.Item
                  label="Lý do (Không hoàn thành/Tạm dừng/Hủy)"
                  rules={[
                    {
                      required:
                        workStatusQuarterValues === StatusType.Postponed ||
                        workStatusQuarterValues === StatusType.Cancel ||
                        workStatusQuarterValues === StatusType.NotCompleted,
                      message: `Hãy nhập lý do`,
                    },
                  ]}
                  name={'unFinishNoteQuarter'}
                >
                  <TextArea rows={6} placeholder="Nhập nhập lý do" size="large" />
                </Form.Item>
              )}
          </Col>
        </Row>

        <hr />
        <Row>
          <Col className="fw-bold h3" md={24}>
            Cập nhật kế hoạch {entity?.adjustment?.name}
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Form.Item label={_.upperFirst(entity?.adjustment?.krNextQuarter?.name)}>
              <InputNumber
                parser={parseNumber}
                formatter={formatNumber}
                disabled
                value={entity?.adjustment?.krNextQuarter?.metricValue}
                className="w-100"
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          {entity?.adjustment?.krApproved.map((x, index) => {
            return (
              <>
                <Col key={`adjust-${index}`} md={4}>
                  <Form.Item
                    label={x?.name}
                    initialValue={x?.metricValue}
                    name={`metricValue-${index}`}
                    rules={[
                      {
                        required:
                          (index === 0 || index === 1 || index === 2)
                            ?
                            true
                            : undefined,
                        message: 'Vui lòng nhập',
                      },
                      {
                        type: 'number',
                        min:
                          krCheckIn?.krType === KrTypes.AccumulateQuantitative
                            ? index === 0
                              ? _.round((entity?.adjustment?.krNextQuarter?.metricValue - ((metricValueSecond ?? 0) + (metricValueThird ?? 0))), 10)
                              : index === 1
                                ? _.round((entity?.adjustment?.krNextQuarter?.metricValue - ((metricValueFirst ?? 0) + (metricValueThird ?? 0))), 10)
                                : index === 2
                                  ? _.round((entity?.adjustment?.krNextQuarter?.metricValue - ((metricValueFirst ?? 0) + (metricValueSecond ?? 0))), 10)
                                  : undefined
                            : undefined,
                        max:
                          krCheckIn?.krType === KrTypes.AccumulateQuantitative
                            ? index === 0
                              ? _.round((entity?.adjustment?.krNextQuarter?.metricValue - ((metricValueSecond ?? 0) + (metricValueThird ?? 0))), 10)
                              : index === 1
                                ? _.round((entity?.adjustment?.krNextQuarter?.metricValue - ((metricValueFirst ?? 0) + (metricValueThird ?? 0))), 10)
                                : index === 2
                                  ? _.round((entity?.adjustment?.krNextQuarter?.metricValue - ((metricValueFirst ?? 0) + (metricValueSecond ?? 0))), 10)
                                  : undefined
                            : undefined,
                        message: 'Giá trị không hợp lệ',
                      },
                    ]}
                  >
                    <InputNumber
                      disabled={krCheckIn?.krType === KrTypes.AccumulateQuantitative && index === 2}
                      step={0.01} precision={2} parser={parseNumber} formatter={formatNumber} className="w-100" size="large" />
                  </Form.Item>
                </Col>
                <Col md={1} />
              </>
            );
          })}
          <Col md={5}>
            <Form.Item label={'Dự báo khả năng thực hiện'} name={'adjustmentPredictNote'}>
              <Input
                placeholder='Nhập dự báo khản năng thực hiện'
                className="w-100"
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Khó khăn & nguyên nhân" name={'issue'}>
              <TextArea rows={6} placeholder="Nhập khó khăn & nguyên nhân" size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Giải pháp và kiến nghị" name={'solution'}>
              <TextArea rows={6} placeholder="Nhập giải pháp và kiến nghị" size="large" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col md={24}>
            <Form.Item label="Tài liệu đính kèm về kết quả thực hiện (link)" name={'krAdjustmentNote'}>
              <TextArea placeholder="Nhập tài liệu đính kèm về kết quả thực hiện" size="large" />
            </Form.Item>
            <Form.Item valuePropName="checked" name={'sendingNotification'}>
              <Checkbox>Gửi thông báo đến người nhận</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Row className="d-flex gap-3 mt-3" justify="end">
            {!hideNextKr && (
              <Col>
                <Button className="green" onClick={handleNextKr} disabled={isUpdating}>
                  Lưu & Chuyển sang check in KR khác
                </Button>
              </Col>
            )}
            <Col>
              <Button
                className="secondary"
                onClick={() => {
                  handleClose();
                }}
              >
                Hủy
              </Button>
            </Col>
            <Col>
              <Button className="primary" htmlType="submit" disabled={isUpdating}>
                Lưu
              </Button>
            </Col>
          </Row>
        </Form.Item>
        {isOpenModalFormObjective && (
          <ObjectiveUpdate isOpen={isOpenModalFormObjective} id={entity?.objective?.id} onClose={handleCloseModelObjective} />
        )}
        {isOpenModalFormKr && (
          <KRUpdate
            isOpen={isOpenModalFormKr}
            idKrBaseSelected={krCheckIn?.id}
            idObjective={entity?.objective?.id}
            krTypeRequest={krCheckIn?.krType}
            planPeriodType={filters?.planPeriodType}
            planPeriodIdSelected={filters?.planPeriodId}
            onClose={handleCloseModelKr}
          />
        )}
      </Form>
    </Spin>
  );
};

export default ReportQuantitativeResult;
